import { memo, useEffect, useRef, useState } from 'react'

import { useQuery, useIsHydrating } from '@muse-web/router'

import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions } from '@core/store'
import { CHECKOUT_PARAMS } from '@features/checkout'
import { useCurrentUser } from '@features/session'

type TPurchaseReturnQuery = {
    [CHECKOUT_PARAMS.success]?: string
    [CHECKOUT_PARAMS.audacitySuccess]?: string
}

export const PurchaseSuccessRunner = memo(() => {
    const isHydrating = useIsHydrating()
    const { isAuthenticated } = useCurrentUser()
    const query = useQuery<TPurchaseReturnQuery>()
    const { openModal } = useActions({ openModal: modalStore.actions.open })
    const hasOpenedRef = useRef(false)

    const [isPurchaseReturnFrozenBeforeStrip] = useState(
        () =>
            query[CHECKOUT_PARAMS.success] === 'true' ||
            query[CHECKOUT_PARAMS.audacitySuccess] === 'true',
    )

    useEffect(() => {
        if (
            isHydrating ||
            hasOpenedRef.current ||
            !isPurchaseReturnFrozenBeforeStrip ||
            !isAuthenticated
        ) {
            return
        }

        hasOpenedRef.current = true
        openModal(DIALOG_IDS.purchaseSuccess)
    }, [isHydrating, isPurchaseReturnFrozenBeforeStrip, isAuthenticated, openModal])

    return null
})
